export const options = [
    {
        text: '全部后代',
        value: 0
    },
    {
        text: '指定结束人物(不含)',
        value: 1
    },
    {
        text: '指定结束世系',
        value: 2
    },
    {
        text: '追溯到先祖',
        value: 3
    }
]
export const catalogues = [
    [
    ],
    [
        {
            name: '王氏谱文',
            spectrumName: '王氏谱文'
        }, {
            name: '王氏谱文',
            spectrumName: '王氏谱文'
        }
    ],
    [
        {
            name: '王氏谱文',
            spectrumName: '王氏谱文'
        }, {
            name: '王氏谱文',
            spectrumName: '王氏谱文'
        }
    ],
    [
        {
            name: '王氏谱文',
            spectrumName: '王氏谱文'
        }, {
            name: '王氏谱文',
            spectrumName: '王氏谱文'
        }
    ]
]
